import datapoints, { logCortanaUsage } from '../datapoints';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePostRequest } from 'owa-ows-gateway';
import { trace } from 'owa-trace';

const DORADO_SEARCH_URL: string = 'ows/api/beta/CortanaSearch';

export default async function executeDoradoSearch(
    messageBody: string,
    correlationId: string
): Promise<any> {
    const requestBody = {
        EmailBody: messageBody,
    };

    logCortanaUsage(
        datapoints.CortanaComposeSearchTriggered.datapoint.name,
        datapoints.CortanaComposeSearchTriggered.datapoint.customData(correlationId)
    );

    const response = await makePostRequest(DORADO_SEARCH_URL, requestBody, correlationId, true);
    if (isSuccessStatusCode(response.status)) {
        try {
            return response.json();
        } catch (error) {
            trace.warn('[executeDoradoSearch] Exception: ' + error.message);
        }
    }

    return undefined;
}
